import { render, staticRenderFns } from "./relicFilesAdd.vue?vue&type=template&id=d46f9d88&scoped=true&"
import script from "./relicFilesAdd.vue?vue&type=script&lang=js&"
export * from "./relicFilesAdd.vue?vue&type=script&lang=js&"
import style0 from "./relicFilesAdd.vue?vue&type=style&index=0&id=d46f9d88&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d46f9d88",
  null
  
)

export default component.exports